import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { getToolbarComponents } from './toolbar-configuration';
export var primaryToolbarPluginKey = new PluginKey('primaryToolbar');
export var createPlugin = function createPlugin(componentRegistry) {
  return new SafePlugin({
    key: primaryToolbarPluginKey,
    state: {
      init: function init(_config, editorState) {
        return {
          components: getToolbarComponents(componentRegistry, editorState)
        };
      },
      apply: function apply(_tr, pluginState) {
        return pluginState;
      }
    }
  });
};